export type BibliotecaStandard = "iso-9001-14001" | "iso-27001-27701";
export type BibliotecaTipo = "oficina" | "medioambiente" | "proveedores";

export type BibliotecaRoute =
  | "/certificaciones/iso-9001-14001/biblioteca"
  | "/certificaciones/iso-9001-14001/biblioteca/oficina"
  | "/certificaciones/iso-9001-14001/biblioteca/medioambiente"
  | "/certificaciones/iso-9001-14001/biblioteca/proveedores"
  | "/certificaciones/iso-27001-27701/biblioteca"
  | "/certificaciones/iso-27001-27701/biblioteca/oficina"
  | "/certificaciones/iso-27001-27701/biblioteca/proveedores";

export type BibliotecaEstadoVigencia =
  | "vigente"
  | "proximo_vencer"
  | "caducado"
  | "sin_vigencia";

export type BibliotecaUsuario = {
  id: number;
  nombre: string;
};

export type BibliotecaDocumento = {
  id: number;
  nombre_documento: string;
  estandar: BibliotecaStandard;
  tipo: BibliotecaTipo;
  fecha_vigencia: string | null;
  estado_vigencia: BibliotecaEstadoVigencia;
  observaciones: string | null;
  mime_type: string | null;
  tamano_bytes: number | null;
  usuario_modificacion: BibliotecaUsuario | null;
  created_at: string | null;
  updated_at: string | null;
};

export type BibliotecaSummary = {
  oficina: number;
  medioambiente: number;
  proveedores: number;
};

export type BibliotecaCategorySummary = {
  total: number;
  vigentes: number;
  proximos_vencer: number;
  caducados: number;
  sin_vigencia: number;
};

export type BibliotecaPagination = {
  current_page: number;
  last_page: number;
  per_page: number;
  total: number;
  from: number | null;
  to: number | null;
};

export type BibliotecaListResponse = {
  data: BibliotecaDocumento[];
  summary: BibliotecaCategorySummary;
  meta: BibliotecaPagination;
  can_manage: boolean;
};

export type BibliotecaSummaryResponse = {
  data: BibliotecaSummary;
  can_manage: boolean;
};

export type BibliotecaFilters = {
  search: string;
  estado: "" | BibliotecaEstadoVigencia;
  carga_desde: string;
  carga_hasta: string;
  vigencia_desde: string;
  vigencia_hasta: string;
  page: number;
};

export type BibliotecaMetadataPayload = {
  fecha_vigencia: string;
  observaciones: string;
};

export const bibliotecaTipoLabels: Record<BibliotecaTipo, string> = {
  oficina: "Oficina",
  medioambiente: "Medioambiente",
  proveedores: "Proveedores",
};

export const bibliotecaStandardLabels: Record<BibliotecaStandard, string> = {
  "iso-9001-14001": "ISO 9001-14001",
  "iso-27001-27701": "ISO 27001-27701",
};

export const bibliotecaTiposPorEstandar: Record<BibliotecaStandard, BibliotecaTipo[]> = {
  "iso-9001-14001": ["oficina", "medioambiente", "proveedores"],
  "iso-27001-27701": ["oficina", "proveedores"],
};


export const bibliotecaParentRoutes: Record<
  BibliotecaStandard,
  "/certificaciones/iso-9001-14001" | "/certificaciones/iso-27001-27701"
> = {
  "iso-9001-14001": "/certificaciones/iso-9001-14001",
  "iso-27001-27701": "/certificaciones/iso-27001-27701",
};

export const bibliotecaStandardRoutes: Record<BibliotecaStandard, BibliotecaRoute> = {
  "iso-9001-14001": "/certificaciones/iso-9001-14001/biblioteca",
  "iso-27001-27701": "/certificaciones/iso-27001-27701/biblioteca",
};

const bibliotecaTipoRoutes: Record<
  BibliotecaStandard,
  Partial<Record<BibliotecaTipo, BibliotecaRoute>>
> = {
  "iso-9001-14001": {
    oficina: "/certificaciones/iso-9001-14001/biblioteca/oficina",
    medioambiente: "/certificaciones/iso-9001-14001/biblioteca/medioambiente",
    proveedores: "/certificaciones/iso-9001-14001/biblioteca/proveedores",
  },
  "iso-27001-27701": {
    oficina: "/certificaciones/iso-27001-27701/biblioteca/oficina",
    proveedores: "/certificaciones/iso-27001-27701/biblioteca/proveedores",
  },
};

export function bibliotecaTipoRoute(
  standard: BibliotecaStandard,
  tipo: BibliotecaTipo,
): BibliotecaRoute {
  return bibliotecaTipoRoutes[standard][tipo] ?? bibliotecaStandardRoutes[standard];
}
